<template>
    <div class="container">
        <back-button location="/initiatives"></back-button>

        <h1 class="title">Tech accelerator</h1>
        <div class="content">
            <div class="introduction">
                <p>
                    This years' Tech Accelerator showcased 7 outstanding projects out of 21 initial projects. Teams of Entelectuals had been hard at work in hackathons, team get-togethers, and their private time over the course of the year to bring their tech passion projects to light, with support from the skills and hardware available at
                    Entelect.
                </p><br/>
                <p>
                    This years' Tech Accelerator introduced hackathons to give teams more time to sit together with fellow Entelectuals and collaborate on their projects. It also encouraged more socially focused projects, under the sub-brand 'Social Accelerator'.
                </p><br/>
                <p>
                    Projects ranged from a music synthesizer to a digital Jukebox. Even a battle of DIY robots battling each other!
                </p><br/>
                <p>
                    The event was judged at Entelect's final DevDay by the leadership team and fellow Entelectuals.
                </p>
            </div>

            <div class="images">
                <div class="image image-border"
                     :style="{ 'background-image': `url(${images.ta1})` }"></div>
                <div class="image image-border inverse"
                     :style="{ 'background-image': `url(${images.ta2})` }"></div>
            </div>

            <div class="stats">
                <stats-icon :icon-src="statsImages.teams" stat="21" title="Participating teams"></stats-icon>
                <stats-icon :icon-src="statsImages.participants" stat="7" title="Final teams"></stats-icon>
                <stats-icon :icon-src="statsImages.techBudget" stat="R 150K" title="Tech budget"></stats-icon>
                <stats-icon :icon-src="statsImages.prizeMoney" stat="R 75K" title="Prize money"></stats-icon>
            </div>

            <div class="projects">
                <h2 class="sub-title">Projects</h2>

                <project-details name="Dragon-Worm.io" :image-src="projectImages.dragonwormImage">
                    <template slot="members">
                        Grant Marais, Huxley Oosthuizen, Thomas Peters
                    </template>
                    <template slot="description">
                        <p>
                            DragonWorm.io is a massively multi-player browser based game, the aim was to create a websocket based game that could support more than a 100 concurrent players. The technologies used are web sockets, pixijs rendering, AOP, SVG, dyn4j physics as well as network compression specifically variable byte encoding. A great deal was learned about game programming and patterns involved. The game still actively being developed and after solving a rendering performance issue it can handle more than 200 concurrent players, we would like to make the game public next year.
                        </p>
                    </template>
                </project-details>

                <project-details name="Dwarf Robot Destruction (aka. Robot Wars)" :image-src="projectImages.dwarfrobotsImage">
                    <template slot="members">Lwazi Prusent, Marcelo Lourenco, Richard Oliver, Robin Swart, Stef Cronje, Wayne Robert, Zane Bloom</template>
                    <template slot="description">
                        <p>
                            We wanted to learn more about Arduinos and electronics, so what better way of doing this than building awesome robots, that try to destroy each other. The four of us in our team each built a robot and then we had a battle royale to determine the ultimate champion. Throughout the year we learned about programming Arduinos, Bluetooth, electronics, soldering, video editing and animation, and holding each other accountable. 
                        </p>
                    </template>
                </project-details>

                <project-details name="IntEvent" :image-src="projectImages.inteventImage">
                    <template slot="members">
                        De Pallier Gerber, Bryn Hill, Jonathan Singmin
                    </template>
                    <template slot="description">
                        <p>
                            Our project facilitates in making the music at parties a more interactive experience. People navigate to the site on their mobile devices and vote for the next song to be played from a presented list. The project makes use of a variety of technologies and frameworks (including React, TypeScript, .net core, and GraphQL), most of which the team members were unfamiliar with. The next steps for this project would be to enhance the personalisation options offered by the site (customisation of song choices), as well as analytics of user behaviour and choices. 
                        </p>
                    </template>
                </project-details>

                <project-details name="Media Cannibal" :image-src="projectImages.mediacannibalImage">
                    <template slot="members">
                        Charl Cilliers, John Lucey, Masilo Mapaila, Zaheer Abrahams
                    </template>
                    <template slot="description">
                        <p>
                            The goal of this project is to lower barriers of entry to low/no cost media creation by creating an open source, unopinionated and universal media creation framework that is able to leverage contributions of programmers independently of the technologies and languages they feel most comfortable employing. So far we have blended FaaS with a custom RPC protocol to create a lightweight pluggable CLI that accepts build files to perform dependency/plugin management and compute media artefacts via a workflow of FaaS functions. Next year we intend to streamline plugin creation and write more plugins.
                        </p>
                    </template>
                </project-details>

                <project-details name="Tunelist" :image-src="projectImages.tunelistImage">
                    <template slot="members">
                        Luke Madzedze
                    </template>
                    <template slot="description">
                        <p>
                            The aim of this project was to create a modern version of the classic Jukebox in the form of a native Android app. The app would allow event hosts to create a music library from their devices, which guests can use to bid for songs played at the event. An event host would have the ability to choose between creating a free-to-play event or one which requires the guests to pay credit coupons per song. The main goal of the project was to build a potentially viable product using a new language Kotlin with Firebase technologies. I had no prior experience with both of these technologies and had to learn within the project timelines. The project is still in active development and the first phase of development which started at the 2018 Tech Accelerator kick-off, will end early 2019 when the app is officially released on the Google Play store. The second phase of the project will immediately start as I seek to get partnership deals with existing streaming services like Spotify, Deezer and Google Play. An IOS and Web client are also on the cards to make service available to as many potential users as possible.
 
                        </p>
                    </template>
                </project-details>

                <project-details name="Web Synth" :image-src="projectImages.websynthImage">
                    <template slot="members">
                        Patrick Stephansen
                    </template>
                    <template slot="description">
                        <p>
                            The idea behind the WebSynth project was to create an entry-level MIDI-based synthesizer that runs on a web page. It was mostly for the sake of my own learning, but teaching people the basics of synthesis was also a goal. The project uses the Web MIDI API to capture input from a MIDI controller, and the Web Audio API to create sounds in response. Visualisations show how the signal is being processed using HTML 5 canvas elements. I learned the basics of MIDI processing, which I plan to use again in future projects. WebSynth’s current implementation is very much a proof of concept. There is plenty of room for more features (modulation, filtering, triggering multiple oscillators per key press, waveform visualization), and it has a way to go to meet the goal of being as friendly to beginners as was planned.
                        </p>
                    </template>
                </project-details>

                <project-details name="Solve4x2" :image-src="projectImages.solve4x2Image">
                    <template slot="members">
                        Marius Kruger, Tiaan Malherbe
                    </template>
                    <template slot="description">
                        <p>
                            Continuing from where we left off last year, we built a basic automated trading platform that can manage dev/test/prod etc environments, gather and plot data, run simulations and run a live trader. We learnt a lot more about Julia, JuliaDB, Julia HTTP, Angular Material, JWT, Forex trading, Hyper parameter optimization, Multi-objective optimization and Flux.jl. We got a bit better at TDD, starting earlier and focussing on an MVP. As soon as we can get a bot profitable we can go big: clean up, scale out and improve testing.
                        </p>
                    </template>
                </project-details>

                <div class="filler-image">
                    <div class="image image-border"
                         :style="{ 'background-image': `url(${images.ta3})` }">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import BackButton from "../../widgets/BackButton";
    import StatsIcon from '../../widgets/StatsIcon';
    import ProjectDetails from '../../widgets/ProjectDetails';
    // Main images imports
    import ta1 from '../../assets/images/Tech Accelerator/ta-1.jpg';
    import ta2 from '../../assets/images/Tech Accelerator/ta-3.jpg';
    import ta3 from '../../assets/images/Tech Accelerator/ta-2.jpg';
    // Project imports
    import dragonwormImage from '../../assets/images/Tech Accelerator/dragon-worm-io.jpg';
    import dwarfrobotsImage from '../../assets/images/Tech Accelerator/dwarf-robot-wars.jpg';
    import inteventImage from '../../assets/images/Tech Accelerator/intevent.jpg';
    import mediacannibalImage from '../../assets/images/Tech Accelerator/mediacannibal.jpeg';
    import tunelistImage from '../../assets/images/Tech Accelerator/tunelist.jpg';
    import websynthImage from '../../assets/images/Tech Accelerator/web-synth.jpg';
    import solve4x2Image from '../../assets/images/Tech Accelerator/solve4x2.jpg';
    // Stats images imports
    import teamsImage from '../../assets/images/Tech Accelerator/team.png';
    import participantsImage from '../../assets/images/Tech Accelerator/boss.png';
    import techBudgetImage from '../../assets/images/Tech Accelerator/virtual-reality.png';
    import prizeMoneyImage from '../../assets/images/Tech Accelerator/money-bag.png';

    export default {
        components: {
            BackButton,
            StatsIcon,
            ProjectDetails
        },
        data: function () {
            return {
                images: {
                    ta1: ta1,
                    ta2: ta2,
                    ta3: ta3,
                },
                projectImages: {
                    dragonwormImage: dragonwormImage,
                    dwarfrobotsImage: dwarfrobotsImage,
                    inteventImage: inteventImage,
                    mediacannibalImage: mediacannibalImage,
                    tunelistImage: tunelistImage,
                    websynthImage: websynthImage,
                    solve4x2Image: solve4x2Image,
                },
                statsImages: {
                    teams: teamsImage,
                    participants: participantsImage,
                    techBudget: techBudgetImage,
                    prizeMoney: prizeMoneyImage,
                }
            };
        },
        methods: {
            track () {
                this.$ga.page('/2018/initiatives/techaccelerator') // This is for Google Analytics tracking
            }
        }
    }
</script>

<style lang="scss" scoped>
    .container {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        grid-template-rows: auto 1fr;
        grid-template-areas: 'back title  .' 'content content content';
        color: white;
        background-size: cover;
        background-position: center;
        padding-bottom: 48px;

        @media only screen and (max-width: $screen-sm-max) {
            grid-template-columns: 1fr 2fr 1fr;
        }

        .title {
            grid-area: title;
            align-self: start;
            justify-self: center;
            margin: 24px;
            display: grid;
            align-content: center;
            justify-content: center;
        }

        .content {
            grid-area: content;
            display: grid;
            grid-template-areas: '. introduction stats .' '. images images .' '. quotes quotes .' '. projects projects .';
            grid-template-columns: 1fr 1fr 1fr 1fr;
            grid-gap: 32px;
            grid-template-rows: auto auto auto;

            @media only screen and (max-width: $screen-md-max) {
                grid-template-columns: 1fr 2fr 2fr 1fr;
                grid-template-areas: '. introduction introduction .' '. stats stats .' '. images images .' '. quotes quotes .' '. projects projects .';

                .stats {
                    grid-auto-flow: column;
                }
            }

            @media only screen and (max-width: $screen-sm-max) {
                grid-template-columns: 1fr 3fr 3fr 1fr;
            }

            @media only screen and (max-width: $screen-xs-max) {
                grid-template-areas:
                        '. introduction .'
                        '. stats .'
                        '. images .'
                        '. quotes .'
                        '. projects .';
                grid-template-columns: 32px 1fr 32px;
                grid-gap: 0;
            }

            .introduction {
                grid-area: introduction;
                text-align: justify;
                font-size: 16px;

                @media only screen and (max-width: $screen-xs-max) {
                    margin-bottom: 32px;
                }
            }

            .images {
                grid-area: images;

                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-auto-rows: 200px;
                grid-auto-flow: column;
                grid-gap: 24px;

                @media only screen and (max-width: $screen-sm-max) {
                    grid-template-columns: 1fr;
                    grid-auto-flow: row;
                }

                .image {
                    background: no-repeat center;
                    background-size: cover;

                    height: 100%;
                }

                @media only screen and (max-width: $screen-xs-max) {
                    margin-bottom: 32px;
                }
            }

            .stats {
                grid-area: stats;
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-gap: 16px;

                @media only screen and (max-width: $screen-md-max) {
                    grid-template-columns: auto;
                }

                @media only screen and (max-width: $screen-xs-max) {
                    grid-template-columns: 1fr 1fr;
                    grid-template-rows: auto auto;
                    margin-bottom: 32px;
                }
            }

            .projects {
                grid-area: projects;
                display: grid;
                grid-template-columns: 1fr 1fr;
                grid-gap: 48px;

                @media only screen and (max-width: $screen-sm-max) {
                    grid-template-columns: 1fr;
                    grid-gap: 24px;
                }

                .sub-title {
                    align-self: center;
                    justify-self: center;
                    margin: 16px 0;
                    grid-column: 1 / span 2;

                    @media only screen and (max-width: $screen-sm-max) {
                        grid-column: 1 / span 1;
                    }
                }

                .filler-image {
                    display: grid;

                    .image {
                        align-self: center;
                        justify-self: center;
                        height: 75%;
                        width: 90%;
                        background: no-repeat center;
                        background-size: cover;

                        @media only screen and (max-width: $screen-sm-max) {
                            height: 200px;
                        }
                    }
                }
            }
        }
    }
</style>
